import type { FinanceFunction } from "@chro/shared";
import { useEexCapability } from "./use-eex-capability";

export function useFinanceFunction(action: FinanceFunction): boolean {
  return useEexCapability(action);
}
